import {createSelector} from 'reselect';
import {get} from 'lodash';

import {getTripData, getSystem} from './store';
import {getLocation} from './searchBox';
import {getSiteName} from './system';
import {parseURL, toURL} from '@homeaway/search-url-parser';

const getSearchUrl = createSelector(
    [getTripData, getLocation, getSiteName, getSystem],
    (tripData, location, siteName, system) => {
        const lastSearchUrl = get(system, 'cookies["ha-state-prst"].lastSearchUrl', '');
        const parsedURL = lastSearchUrl ? parseURL(lastSearchUrl, {name: siteName}) : {};
        return toURL({
            arrival: tripData.arriveDateText,
            departure: tripData.departDateText,
            q: location ? location : '',
            adultsCount: tripData.adults,
            childrenCount: tripData.children,
            petIncluded: tripData.hasPets,
            filter: parsedURL.filter ? parsedURL.filter : []
        });
    }
);

const getSearchBaseUrl = createSelector(
    [getTripData, getSiteName, getSystem],
    (tripData, siteName, system) => {
        const lastSearchUrl = get(system, 'cookies["ha-state-prst"].lastSearchUrl', '');
        const parsedURL = lastSearchUrl ? parseURL(lastSearchUrl, {name: siteName}) : {};
        return toURL({
            arrival: tripData.arriveDateText,
            departure: tripData.departDateText,
            adultsCount: tripData.adults,
            childrenCount: tripData.children,
            petIncluded: tripData.hasPets,
            filter: parsedURL.filter ? parsedURL.filter : []
        });
    }
);

export default getSearchUrl;

export {getSearchUrl, getSearchBaseUrl};
